export const DELETE_AA_FAMILY_MEMBER_MODAL_NAME =
  'DELETE_AA_FAMILY_MEMBER_MODAL_NAME';
